export const name = 'checkmark';

export const Checkmark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60681 15.9154L7.52477 13.8334L5.01061 11.3192L3.94995 12.3799L6.46411 14.894L9.60681 18.0367L10.1371 17.5064L10.1371 17.5064L10.6675 16.9761L20.0366 7.60689L18.9759 6.54623L9.60681 15.9154Z"
      fill="currentColor"
    />
  </svg>
);
